import React from 'react';

import { createAndShowChatSessionWithSettingsClosed } from 'flow/actions/chat-actions';
import NumberWrapper from 'flow/components/ui-components/NumberWrapper';
import { useRowTabIndex } from 'flow/components/ui-components/row-tab-stop';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { removeExtraCharacters } from 'flow/utils/call-utils';

type Props = {
    searchText: string;
};

/** Starts an SMS chat with the number in the search field, offered while
 *  searching when nobody holds that number. */
const SmsChatListItem = ({ searchText }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const rowTabIndex = useRowTabIndex();

    const handleSMSConversation = () => {
        const strippedNumber = removeExtraCharacters(searchText);
        const chatSession = {
            members: [{ mobileNumber: strippedNumber }],
        };

        dispatch(createAndShowChatSessionWithSettingsClosed(chatSession));
    };

    return (
        <button
            type="button"
            className="focus-ring-inset flex h-13 w-full items-center justify-between gap-x-3 rounded-sm p-2 hover:bg-gray-200"
            onClick={handleSMSConversation}
            tabIndex={rowTabIndex}
        >
            <p className="overflow-hidden text-ellipsis whitespace-nowrap">
                <NumberWrapper>{searchText}</NumberWrapper>
            </p>

            <p className="color-mid-grey text-sm uppercase">
                {i18next.t('option.sms')}
            </p>
        </button>
    );
};

export default React.memo(SmsChatListItem);
